const DEFAULT_ERROR_MESSAGE = 'We\'ve experienced an issue while processing your request, Please try again.';

export default {
  methods: {
    toastDanger(message, title = 'Oops!') {
      if (!this.$bvToast) {
        return;
      }

      const text = Array.isArray(message) ? message.join(', ') : message;

      this.$bvToast.toast(text, {
        title,
        toaster: 'b-toaster-bottom-right',
        variant: 'danger',
        autoHideDelay: 5000,
        appendToast: false,
      });
    },
    async extractErrorMessage(error, fallbackMessage = DEFAULT_ERROR_MESSAGE) {
      const response = error?.response;
      const data = response?.data;

      if (!data) {
        return fallbackMessage;
      }

      const errors = data?.errors;
      if (Array.isArray(errors)) {
        const messages = [];
        errors.forEach((serverError) => {
          if (!serverError || !Array.isArray(serverError.errors) || serverError.errors.length === 0) {
            return;
          }
          if (serverError.field === 'base') {
            messages.push(...serverError.errors);
          } else if (serverError.field) {
            messages.push(`${serverError.field} ${serverError.errors.join(', ')}`);
          } else {
            messages.push(...serverError.errors);
          }
        });
        if (messages.length > 0) {
          return messages.join(', ');
        }
      }

      const message = data?.message;
      if (typeof message === 'string' && message.length > 0) {
        return message;
      }

      if (typeof data === 'string' && data.length > 0) {
        return data;
      }

      if (data && typeof data.text === 'function') {
        try {
          const text = await data.text();
          if (typeof text === 'string' && text.length > 0) {
            try {
              const parsed = JSON.parse(text);
              if (typeof parsed?.message === 'string' && parsed.message.length > 0) {
                return parsed.message;
              }
            } catch (_e) {
              return text;
            }
            return text;
          }
        } catch (_e) {
          return fallbackMessage;
        }
      }

      return fallbackMessage;
    },
    async displayErrorToast(error, { fallbackMessage = DEFAULT_ERROR_MESSAGE, title = 'Oops!' } = {}) {
      const message = await this.extractErrorMessage(error, fallbackMessage);
      this.toastDanger(message, title);
      return false;
    },
  },
};

